var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.289 57.2812V133.802C119.289 138.33 115.631 142 111.117 142H44.3786C39.8653 142 36.2065 138.33 36.2065 133.802V44.9878C36.2065 40.46 39.8653 36.7896 44.3786 36.7896H97.968",
    fill: "url(#paint0_linear_400_34390)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.289 57.2812L106.14 57.2812C101.627 57.2812 97.9678 53.6108 97.9678 49.083L97.9678 36.7896",
    fill: "#EAADBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 73C61.3447 73 75 60.9117 75 46C75 31.0883 61.3447 19 44.5 19C27.6553 19 14 31.0883 14 46C14 60.9117 27.6553 73 44.5 73Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1411 43.5399L49.749 32.4307L50.1095 55.1776L64.1411 43.5399Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1362 50.825C53.1362 50.825 39.5341 40.1458 25.6738 60.1735C30.681 34.6803 53.5746 39.2016 53.5746 39.2016L53.1362 50.825Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 82C137.433 82 139 80.433 139 78.5C139 76.567 137.433 75 135.5 75C133.567 75 132 76.567 132 78.5C132 80.433 133.567 82 135.5 82Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127 47C128.105 47 129 46.5523 129 46C129 45.4477 128.105 45 127 45C125.895 45 125 45.4477 125 46C125 46.5523 125.895 47 127 47Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18C63.6569 18 65 16.433 65 14.5C65 12.567 63.6569 11 62 11C60.3431 11 59 12.567 59 14.5C59 16.433 60.3431 18 62 18Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.938 90.5385L127.235 88.8306L125.533 90.5385L127.235 92.2465L128.938 90.5385Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5428 27.0024L76.8403 25.2944L75.1378 27.0024L76.8403 28.7104L78.5428 27.0024Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.548 10.458L99.0441 12.3178C98.854 12.5528 98.854 12.8894 99.0441 13.1244L100.548 14.9842L98.6945 13.4751C98.4602 13.2844 98.1248 13.2844 97.8905 13.4751L96.0366 14.9842L97.5409 13.1244C97.731 12.8894 97.731 12.5528 97.5409 12.3178L96.0366 10.458L97.8905 11.9671C98.1248 12.1578 98.4602 12.1578 98.6945 11.9671L100.548 10.458Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.992 12.7211L98.6082 13.0379L98.2924 19.4422L97.9766 13.0379L91.5928 12.7211L97.9766 12.4042L98.2924 6L98.6082 12.4042L104.992 12.7211Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1997 85.353L19.9825 88.0942C19.7023 88.4406 19.7023 88.9366 19.9825 89.2831L22.1997 92.0242L19.4673 89.8C19.122 89.5188 18.6275 89.5188 18.2822 89.8L15.5498 92.0242L17.767 89.2831C18.0472 88.9366 18.0472 88.4406 17.767 88.0942L15.5498 85.353L18.2822 87.5773C18.6275 87.8584 19.122 87.8584 19.4673 87.5773L22.1997 85.353Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7492 88.6884L19.3401 89.1554L18.8746 98.5946L18.4091 89.1554L9 88.6884L18.4091 88.2214L18.8746 78.7822L19.3401 88.2214L28.7492 88.6884Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_34390",
    x1: 78.0526,
    y1: 30.5534,
    x2: 77.4376,
    y2: 148.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF849D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156084,
    stopColor: "#EB829A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288855,
    stopColor: "#E17C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413102,
    stopColor: "#CF7288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532212,
    stopColor: "#B66478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647724,
    stopColor: "#965363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760468,
    stopColor: "#6F3D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871004,
    stopColor: "#40232A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977148,
    stopColor: "#0C0608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.809b472727aa922a3f0258e961244b53.svg";
export { ForwardRef as ReactComponent };